import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type Creator = OpalApiResponseDocument<
  'ExperimentalReadBlockBFFV1',
  200
>['data']['boards'][number]['creator']

export const creatorFactory: Factory<Creator> = Factory.define<Creator>(
  ({ sequence }) =>
    ({
      id: uuidV4(),
      legacy_id: sequence.toString(),
      full_name: `Mock User ${sequence}`,
      avatar_url: null,
    }) satisfies Creator
)
